import { CalendarTranslateService } from 'app/modules/UIKit/services/calendarTranslate.service';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-loyalty-reservation-details',
  templateUrl: './loyalty-reservation-details.component.html',
  styleUrls: ['./loyalty-reservation-details.component.css']
})
export class LoyaltyReservationDetailsComponent implements OnInit {
  @Input() record = {};

  balanceData: any = {};

  constructor(public calendarTranslateService: CalendarTranslateService) { }

  ngOnInit() {
    this.balanceData = {
      customer: sessionStorage.getItem('customerFullName'),
      email: sessionStorage.getItem('email'),
      telephone: sessionStorage.getItem('telephone')
    }

    console.log(this.balanceData);
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-reservation-details/loyalty-reservation-details.component.ts